var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-toolbar',{attrs:{"flat":"","color":"dark","dark":""}},[_c('v-toolbar-title',[_c('span',{staticClass:"pl-2"},[_vm._v("School schedule")])])],1),_c('v-card-text',[_c('v-alert',{staticClass:"mb-0",attrs:{"type":"info","dense":"","outlined":""}},[_vm._v(" Functionaliteit volgt in een volgende stap. ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }